// extracted by mini-css-extract-plugin
module.exports = {"toggle":"select_toggle__wge47","dropdown":"select_dropdown__1qWCN"};